import barcodeimage from '../assets/barcode.png'
import React from 'react';

interface Props {
    imagePreview: any,
    headingValue: string,
    storeName: string,
    transactionMsgValue: string,
    flavourTextValue: string,
    gst: string,
    isLoading?: boolean
} 

const items = [
  {
    name: 'Gift Tag Gold Present',
    price: 1.00
  },
  {
    name: 'Kiddy Cruisers - Single Hour',
    price: 5.00
  },
  {
    name: 'Gift Tag HB Balloon',
    price: 2.00
  },
];

const ReceiptPreview = ({imagePreview, headingValue, storeName, transactionMsgValue, flavourTextValue, gst, isLoading}:Props) => {
    const calculateTotal = (itemsC: {name: string, price: number}[]) => {
        let total = 0;
        itemsC.forEach(item => {
            total += item.price;
        });
        return total;
    };

    return (
      <div className='ml-10 relative pb-6'>
        <div className={`${isLoading && "bg-gray-300 opacity-30"} absolute h-full w-full`}></div>
        <div className="shadow-md flex text-center bg-white justify-center font-monospace items-center flex-col text-xs px-8">
          {/* Fixed condition: check if imagePreview exists and is not empty string */}
          {imagePreview && imagePreview.trim() !== '' && 
            <img src={imagePreview} alt="logo" className='max-h-8 mt-5' />
          }
          {/* <img src={"https://kupid-images-uat.s3.ap-southeast-2.amazonaws.com/receipt-format/westfield.png"} alt="logo" className='max-h-8 mt-5' /> */}
          <p className='mt-4 mb-3'>{headingValue}</p>
          <div>
          {storeName.split(/\r?\n/).map((line, index) => (
              <React.Fragment key={index}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </div>
          <p>Served by: Jane Doe</p>
          <p>Date: 24/04/2024  Time: 3:18pm</p>
          <p>{gst}</p>
          <p>Transaction number: 2007039001240424151818</p>
          <p>Trace number: 240424151818</p> 
          <p>IOU code:</p>
          <p className='mt-2'>Purchase Information</p>
          <div className='w-96'>
          <p>-----------------------------------------------------</p>
          {items.map((item: any, index: number) => (
            <div key={index} className='flex justify-between'>
                <p>{item.name}</p>
                <p>{item.price.toFixed(2)}</p>
            </div>
          ))}
          <div className='flex justify-between mt-2'>
            <p>PURCHASE TOTAL:</p>
            <p>{calculateTotal(items).toFixed(2)}</p>
          </div>
          <div className='flex justify-between'>
            <p>DISCOUNT TOTAL:</p>
            <p>0.00</p>
          </div>
          <p>-----------------------------------------------------</p>
          <div className='flex justify-between'>
            <p>TOTAL TO PAY:</p>
            <p>{calculateTotal(items).toFixed(2)}</p>
          </div>
          <p>-----------------------------------------------------</p>
          <div className='flex justify-between'>
            <p>TOTAL includes NZ GST of:</p>
            <p>0.00</p>
          </div>
          <div className='flex justify-between'>
            <p>TOTAL includes GST Exc of:</p>
            <p>0.00</p>
          </div>
          <p className='my-4'>{transactionMsgValue}</p>
          <div className='flex justify-between'>
            <p>Cash</p>
            <p>2.00</p>
          </div>
          <div className='flex justify-between'>
            <p>Gift Card XXXX XX68 1357 2468 </p>
            <p>6.00</p>
          </div>
          <div className="my-4">
          {flavourTextValue.split(/\r?\n/).map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          ))}
          </div>
          <img className='w-40 mx-auto mb-4' src={barcodeimage} alt="barcode" />
          </div>
        </div>
      </div>
    )
}

export default ReceiptPreview